

function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

___$insertStyle(".endless-scroll-loader-wrapper {\n  position: relative;\n  pointer-events: none;\n}\n\n.endless-scroll-loader {\n  bottom: 0px;\n  height: 100px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}");

function EndlessScroll(_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, hasMore = _a.hasMore, isLoading = _a.isLoading, onReachBottom = _a.onReachBottom, _c = _a.threshold, threshold = _c === void 0 ? 0.0 : _c;
    var loader = React__namespace.useRef(null);
    React__namespace.useEffect(function () {
        var loadMore = function (entries) {
            var first = entries[0];
            if (!isLoading && hasMore && first.isIntersecting) {
                onReachBottom();
            }
        };
        var options = { threshold: threshold };
        var observer = new IntersectionObserver(loadMore, options);
        var loaderCurrent = loader.current;
        if (loaderCurrent) {
            observer.observe(loaderCurrent);
        }
        return function () {
            if (loaderCurrent) {
                observer.unobserve(loaderCurrent);
            }
        };
    }, [hasMore, isLoading, onReachBottom, threshold]);
    return (React__namespace.createElement("div", { className: "endless-scroll-wrapper ".concat(className) },
        children,
        React__namespace.createElement("div", { className: "endless-scroll-loader-wrapper" },
            React__namespace.createElement("div", { ref: loader, className: "endless-scroll-loader" }))));
}

exports["default"] = EndlessScroll;
//# sourceMappingURL=index.js.map
